<template>
  <div>
    <el-dialog
      title="确认客户所属业务员"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
    >
      <div class="dl-page" style="height: 220px; min-height: 220px">
        <div class="remarks">
          说明：更改业务员后，新订单给新业务员分成，历史未完结订单仍给旧业务员分成
        </div>
        <div
          class="row v-gap"
          v-if="type === 1 || (type === 2 && client.salesJobNumber)"
        >
          <div class="col">
            <div class="row">
              <div class="tip">当前业务员ID：</div>
              <div class="value">
                {{
                  type === 2
                    ? client.salesJobNumber
                    : rowData
                    ? rowData.salesJobNumber
                    : ""
                }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="tip">当前业务员手机号：</div>
              <div class="value">
                {{
                  type === 2
                    ? client.contactInformation
                    : rowData
                    ? rowData.contactInformation
                    : ""
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="row v-gap-small">
          <div class="tip">选择新业务员：</div>
          <div class="fill-wrap" style="width: 360px">
            <el-select
              :value="displayValue"
              placeholder="请输入业务员ID/业务员手机号/业务员姓名"
              size="small"
              value-key="salesUserId"
              filterable
              remote
              :remote-method="doLoadSales"
              :loading="loading"
              @change="handleChange"
            >
              <el-option
                v-for="item in listData"
                :key="item.salesUserId"
                :label="item.salesUserName"
                :value="item"
              >
                <div class="row">
                  <span style="margin-right: 6px">{{
                    item.salesJobNumber
                  }}</span>
                  <span style="margin-right: 6px">{{
                    item.contactInformation
                  }}</span>
                  <span>{{ item.salesUserName }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="right">
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button size="small" type="primary" @click="submitUpload()"
            >确认</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import {
  querySalesUserMsg,
  customerTransfer,
  getSalesUserDetailsBySalesIdVO,
  customerRelationSalesUser,
} from "@/api/externalSalesRule/index.js";

export default {
  components: { MyTable },
  props: {},
  computed: {},
  data() {
    return {
      displayValue: null,
      cities: [{ id: 1, label: "label", label2: "label2", label3: "label3" }],

      dialogVisible: false,

      rowData: null,
      selectedList: null,

      listData: [],
      loading: false,

      transferAll: false,
      selectedParent: null,

      type: 1,
    };
  },
  methods: {
    doLoadSales(query) {
      if (query) {
        const params = {
          nameLike: query,
        };
        this.loading = true;
        querySalesUserMsg(params)
          .then((data) => {
            this.loading = false;
            if (data) {
              this.listData = data;
            } else {
              this.listData = [];
            }
          })
          .catch(() => {
            this.loading = false;
            this.listData = [];
          });
      }
    },
    handleChange(val) {
      if (val) {
        this.displayValue =
          val.salesJobNumber +
          " " +
          val.contactInformation +
          " " +
          val.salesUserName;

        this.selectedParent = val;
      }
    },
    doTranslate() {
      const data = {
        shopId: this.client.id,
        shopName: this.client.shopName,
        shopContactInformation: this.client.loginUserName,
        userId: this.client.ownerUserId,
        salesUserId: this.selectedParent.salesUserId,
      };

      customerRelationSalesUser(data).then((res) => {
        if (res) {
          this.$message.success("转移成功");
          this.dialogVisible = false;

          this.$emit("update");
          // this.$bus.$emit("refresh");
        } else {
          this.$message.error("转移失败");
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    submitUpload() {
      if (!this.selectedParent) {
        this.$message.warning("请选择新业务员");
        return;
      }

      if (this.type === 2) {
        this.doTranslate();
        return;
      }

      const data = {
        salesUserId: this.rowData.id,
        transferSalesUserId: this.selectedParent.salesUserId,
        customerIdList: this.selectedList
          ? this.selectedList.map((item) => item.id)
          : [],
        transferAll: this.transferAll,
      };
      customerTransfer(data).then((res) => {
        if (res) {
          this.$message.success("转移成功");
          this.dialogVisible = false;

          this.$bus.$emit("refresh");
        } else {
          this.$message.error("转移失败");
        }
      });
    },
    clear() {
      this.selectedList = null;
      this.listData = [];
      this.displayValue = "";
      this.selectedParent = null;

      this.client = null;
      this.tableData = [];
    },
    open(selectedList, rowData, transferAll) {
      this.clear();
      this.dialogVisible = true;
      this.type = 1;

      this.selectedList = selectedList;
      this.rowData = rowData;
      this.transferAll = transferAll;
    },
    open2(item) {
      this.clear();
      this.dialogVisible = true;
      this.type = 2;

      this.client = item;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/index.scss";
.form-centent {
  .row {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .tip {
      width: 4em;
    }

    .value {
      width: 240px;
      margin-left: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>
